export class UserHelper {
    static findAndGetDuplicateEmailIds(users: any[]) {
        const uniqueEmailIds = new Set();
        const duplicateEmailIds = new Set();
        users.map(x => x.emailId).forEach(x => {
            uniqueEmailIds.has(x) ? duplicateEmailIds.add(x) : uniqueEmailIds.add(x);
        });
        return [...duplicateEmailIds];
    }
}